module.exports = __webpack_public_path__ + "img/06.1771fb41.png";